export const root = "r1q8gjg3";
export const urgent = "ubq0hd6";
export const clearBg = "c1qmx99p";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");